import {getWeekList, Language, MontShortNameList, TimeFormat} from "../common/customEnum";
import moment from "moment";
import {languagePackage} from "../common/language";

const FormatTool = {
	formatEnglishName(last, first, mid, titleName, type, modifier = 1) {
		let employeeType = type ? type.trim().toUpperCase() : ''

		if (window.GLOBAL_CONFIG.userSelectedLanguage === Language.chinese && titleName && titleName.trim()) {
			return titleName + (employeeType ? ', ' + employeeType : '');
		}

		let firstName = first ? StringTool.titleCase(first.trim()) : ''
		// let midName = mid ? mid.trim().toUpperCase() : ''
		let lastName = last ? StringTool.titleCase(last.trim()) : ''

		let doctorName = ''
		if (modifier===1) {
			// (first name first) Harry D. Smith, MD
			doctorName = employeeType ? `${firstName} ${lastName}, ${employeeType}` : `${firstName} ${lastName}` //firstName + (midName ? ' ' + midName + '.': '') + ' ' + lastName + (employeeType ? ', ' + employeeType : '')
		} else {
			// Smith, Harry D. MD
			doctorName = employeeType ? `${lastName}, ${firstName} ${employeeType}` : `${lastName}, ${firstName}` //lastName + ', ' + firstName + (midName ? ' ' + midName + '.': '') + (employeeType ? ' ' + employeeType : '');
		}
		return doctorName
	},
	formatAddress(address, city, state, zip) {
		let visitLocation = '';
		if (address) {
			visitLocation += StringTool.titleCase(address.trim())
		}
		if (city) {
			visitLocation += (', ' + StringTool.titleCase(city.trim()))
		}
		if (state) {
			visitLocation += (', ' + state.trim().toUpperCase())
		}
		if (zip) {
			visitLocation += (' ' + zip)
		}
		return visitLocation
	},
	formatDate(str) {
		//Input ISO Date string i.e. ('2019-07-09T16:57:29')
		let date = str ? new Date(str) : new Date();

		let	year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();

		if (day < 10) {
			day = '0' + day;
		}
		if (month < 10) {
			month = '0' + month;
		}
		let newDate = month + '/' + day + '/' + year
		return newDate
	},
	formatDateTime(dateTime){
		const hour = parseInt(dateTime)
		if (hour < 12) {
			return dateTime + ' am'
		}else {
			let prefix = ''
			if (hour === 12) {
				prefix = '12'
			}else {
				if (hour - 12 < 10) {
					prefix = '0' + (hour - 12)
				}else {
					prefix = (hour - 12) + ''
				}
			}
			let min = dateTime.substr(2, 3)
			return prefix + min + ' pm'
		}
	}
};

const StringTool = {
	titleCase(name) {
		// Capitalize the first letter of each word, other lowercase
		let reg = /\b(\w)|\s(\w)/g;
		name = name.toLowerCase();
		return name.replace(reg, (letter) => {return letter.toUpperCase()})
	},
	stringToByte(str) {
		let buf = new ArrayBuffer(64);
		let bufView = new Uint16Array(buf);
		for (let i=0, strLen=str.length; i<strLen; i++) {
			bufView[i] = str.charCodeAt(i);
		}
		return buf;
	},
	strReverse(text) {
		return text.split('').map(function (char) {
			return char.charCodeAt(0).toString(2);
		}).join(' ');
	},
	strReplace(origin, pattern, replacement) {
		if (!origin || (typeof origin !== "string")) {
			return ''
		}

		return origin.replace(pattern, replacement)
	},
	isEqual(str1, str2, caseInsensitive = false) {
		let _str1 = str1 || '';
		let _str2 = str2 || '';
		return caseInsensitive ? (_str1 === _str2) : (_str1.toUpperCase() === _str2.toUpperCase())
	}
};

const UrlTool = {
	queryParamFromGetRequest(url) {
		if (!url || !url.length) {
			return {}
		}

		let arr = url.split('?')
		if (arr && arr.length > 1) {
			let search = arr[1]
			let replace1 = StringTool.strReplace(search, /&/g, '","')
			let replace2 = StringTool.strReplace(replace1, /=/g, '":"')
			let param = JSON.parse('{"' + replace2 + '"}', (key, value)=> { return key === ""? value : decodeURIComponent(value) })

			return param ? param : {}
		}else {
			return {}
		}
	},
};

const ObjectTool = {
	// 对比两个对象的值是否完全相等 返回值 true/false
	isObjectValueEqual(a, b, ignoreKey) {
		//取对象a和b的属性名
		let aProps = Object.getOwnPropertyNames(a);
		let bProps = Object.getOwnPropertyNames(b);
		//判断属性名的length是否一致
		if (aProps.length !== bProps.length) {
			return false;
		}
		//循环取出属性名，再判断属性值是否一致
		for (let i = 0; i < aProps.length; i++) {
			let propName = aProps[i];
			if (ignoreKey && propName === ignoreKey) {
				continue;
			}
			if (a[propName] !== b[propName]) {
				return false;
			}
		}
		return true;
	}
};

const ValidateTool = {
	verifyEmail(email) {
		let mailRex = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\.){1,63}[a-z0-9]+$/
		return mailRex.test(email)
	}
};

const DateTool = {
	/**
	 * @Desc   format date to "Jan 01, 2000"
	 * @Params date: Date | string, string like "2000-01-01T13:00:00"
	 * @Return
	 */
	parseReadableDateStrFromDate(date) {
		const m = date instanceof Date ? moment(date) : moment(date, TimeFormat.YYYYMMDDTHHmmss)
		return m ? `${MontShortNameList[m.month()]} ${m.date()}, ${m.year()}` : ""
	},
	/**
	 * @Desc   format date to "01:00 PM"
	 * @Params date: Date | string, string like "2000-01-01T13:00:00"
	 * @Return
	 */
	parseReadableTimeStrFromDate(date) {
		const m = date instanceof Date ? moment(date) : moment(date, TimeFormat.YYYYMMDDTHHmmss)
		if (m) {
			const hour = m.hour()
			const min = m.minute()
			if (hour < 10) {
				if (min < 10) {
					return `0${hour}:0${min} AM`
				} else {
					return `0${hour}:${min} AM`
				}
			} else if (hour < 12) {
				if (min < 10) {
					return `${hour}:0${min} AM`
				} else {
					return `${hour}:${min} AM`
				}
			} else if (hour === 12) {
				if (min < 10) {
					return `12:0${min} PM`
				} else {
					return `12:${min} PM`
				}
			} else if (hour - 12 < 10) {
				if (min < 10) {
					return `0${hour - 12}:0${min} PM`
				} else {
					return `0${hour - 12}:${min} PM`
				}
			} else if (hour === 24) {
				if (min < 10) {
					return `00:0${min} AM`
				} else {
					return `00:${min} AM`
				}
			} else {
				if (min < 10) {
					return `${hour - 12}:0${min} PM`
				} else {
					return `${hour - 12}:${min} PM`
				}
			}
		} else {
			return ""
		}
	},
	/**
	 * @Desc   format date to "Jan 01, 2000, 01:00 PM"
	 * @Params date: Date | string, string like "2000-01-01T13:00:00"
	 * @Return
	*/
	parseReadableDateTimeStrFromDate(date) {
		return `${DateTool.parseReadableDateStrFromDate(date)}, ${DateTool.parseReadableTimeStrFromDate(date)}`
	},
	/**
	 * @Desc   get readable date string,like: 8:48pm Yesterday Saturday 2020-07-13
	 * @Params
	 * @Return
	*/
	getReadableStrFromDate(date) {
		const m = moment(date, TimeFormat.YYYYMMDDTHHmmss)
		if (m.isSame(moment(), "day")) {
			return DateTool.parseReadableTimeStrFromDate(date)
		} else if (m.clone().add(1, "day").isSame(moment(), "day")) {
			return languagePackage().Yesterday
		} else {
			if (m.week() === moment().week()) {
				const weekList = getWeekList()
				const weekday = m.weekday()
				if (weekList.length > weekday) {
					return weekList[weekday]
				}
			}
			return m.format(TimeFormat.YYYYMMDD)
		}
	}
}

const NumberTool = {
	strip(num) {
		return parseFloat(num.toPrecision(12));
	},
	isFloatNumberEqual(left, right) {
		return Math.abs(left - right) < Number.EPSILON * Math.pow(2, 2);
	},
	parseIntFromStr(str) {
		let n = parseInt(str);
		if (!isNaN(n)) {
			return n
		}else {
			return undefined
		}
	},
	fixDigit(str, num = 1) {
		if (typeof str === "string") {
			const fl = parseFloat(str)
			if (isNaN(fl)) {
				return ""
			} else {
				const n = fl.toFixed(num)
				return n.endsWith(".0") ? n.slice(0, -2) : fl.toFixed(num)
			}
		} else if (typeof str === "number") {
			const n = str.toFixed(num)
			return n.endsWith(".0") ? n.slice(0, -2) : str.toFixed(num)
		}
	}
};

const Dimensions = {
	width: window.screen.width,
	height: window.screen.height
}

export {
	FormatTool,
	Dimensions,
	UrlTool,
	ObjectTool,
	ValidateTool,
	StringTool,
	DateTool,
	NumberTool,
}
